import { heroImages } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src={heroImages.contentBg}
        alt="Pandabuy spreadsheet curated finds background"
        title="Explore PandabuySpreadsheet Hub"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative w-full px-4 md:px-10 max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">
          Ready to Explore the Best <span className="text-primary-300">Pandabuy Sheet</span>?
        </h2>
        <p className="text-sm text-white/80 max-w-xl mx-auto mb-8">
          Thousands of curated items across 14 categories — all organized in one convenient pandabuy spreadsheet hub. Start discovering your next favorite find today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold font-label bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Open Pandabuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold font-label bg-white/95 text-foreground-950 rounded-lg hover:bg-white transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}